(() => {
  const SELECTORS = {
    offer: '[data-vip-offer]',
    checkbox: '[data-vip-checkbox]',
    error: '[data-vip-error]',
    productForm: 'form[data-type="add-to-cart-form"]'
  };

  /**
   * Checks whether the VIP variant is already in the cart.
   * This prevents the membership from being added multiple times.
   */
  async function vipAlreadyInCart(vipVariantId) {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to check the cart.');
    }

    const cart = await response.json();

    return cart.items.some(
      (item) => Number(item.variant_id) === Number(vipVariantId)
    );
  }

  /**
   * Adds the Simplee membership variant with its Shopify selling plan.
   */
  async function addVipMembership(vipVariantId, sellingPlanId) {
    const response = await fetch(
      `${window.Shopify.routes.root}cart/add.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(vipVariantId),
              quantity: 1,
              selling_plan: Number(sellingPlanId)
            }
          ]
        })
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        'The VIP membership could not be added.'
      );
    }

    return result;
  }

  /**
   * Intercepts the standard product form only when the VIP checkbox
   * is selected. After adding VIP, it allows Ascendify's normal product
   * submission to continue so its cart drawer still opens.
   */
  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target.closest(SELECTORS.productForm);

      if (!form) return;

      const productFormElement = form.closest('product-form');
      const offer = productFormElement?.querySelector(SELECTORS.offer);

      if (!offer) return;

      const checkbox = offer.querySelector(SELECTORS.checkbox);
      const errorElement = offer.querySelector(SELECTORS.error);

      if (!checkbox?.checked) return;

      /*
       * On the second submission, allow Ascendify to handle the form
       * normally without intercepting it again.
       */
      if (form.dataset.vipReady === 'true') {
        delete form.dataset.vipReady;
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitButton =
        event.submitter ||
        form.querySelector('button[type="submit"][name="add"]');

      const vipVariantId = offer.dataset.vipVariantId;
      const sellingPlanId = offer.dataset.vipSellingPlanId;

      if (!vipVariantId || !sellingPlanId) {
        showError(
          errorElement,
          'VIP membership configuration is missing.'
        );
        return;
      }

      clearError(errorElement);
      setLoadingState(submitButton, true);

      try {
        const alreadyInCart = await vipAlreadyInCart(vipVariantId);

        if (!alreadyInCart) {
          await addVipMembership(vipVariantId, sellingPlanId);
        }

        /*
         * Mark the form so the next submission passes through to
         * Ascendify's existing product-form JavaScript.
         */
        form.dataset.vipReady = 'true';

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submitButton);
        } else {
          submitButton.click();
        }
      } catch (error) {
        console.error('PeachyLift VIP add-on error:', error);

        showError(
          errorElement,
          error.message ||
            'The VIP membership could not be added. Please try again.'
        );

        setLoadingState(submitButton, false);
      }
    },
    true
  );

  function showError(element, message) {
    if (!element) return;

    element.textContent = message;
    element.hidden = false;
  }

  function clearError(element) {
    if (!element) return;

    element.textContent = '';
    element.hidden = true;
  }

  function setLoadingState(button, loading) {
    if (!button) return;

    button.disabled = loading;
    button.setAttribute('aria-busy', loading ? 'true' : 'false');

    const spinner = button.querySelector('.loading-overlay__spinner');

    if (spinner) {
      spinner.classList.toggle('hidden', !loading);
    }
  }
})();